is_the_radiance = window.location.href.indexOf("the-radiance") > -1 || window.location.href.indexOf("the-glow") > -1;
is_the_glow = window.location.href.indexOf("the-glow") > -1;
var $prod_info_price = jQuery("product-info .price");
$prod_info_price.css("opacity", 0);
setTimeout(function () {
  $prod_info_price.css("opacity", 1);
}, 1500);
jQuery(document).ready(function () {
  //   document.querySelector('.vjs-tech').addEventListener('play',  evt => {
  //    jQuery('.video-js').removeClass('vjs-1-1').addClass('vjs-9-16')
  // });
  //not sure why this creates a duplicate so disabled for now
  // $lp_benefits_mobile = jQuery('.lp_benefits_mobile');
  //  if ($lp_benefits_mobile.length > 0) {
  //    var $benefits_container = jQuery('.benefits_container');
  //    $benefits_container.removeClass('hidden')
  //    $lp_benefits_mobile.html($benefits_container)
  //  }
  if (jQuery(".video-js").length > 0) {
    var myPlayers = Array(videojs("vid1"), videojs("vid2"));
    myPlayers.forEach(function (player) {
      player.on("play", function () {
        jQuery("#" + player.id())
          .removeClass("vjs-1-1")
          .addClass("vjs-9-16");
      });
    });
  }
  var $product_tax = jQuery(".product__tax");
  var $free_shipping = jQuery(".product_page_tips");
  if (
    $free_shipping.length > 0 &&
    Number(
      $product_tax
        .prev()
        .find(".price-item--regular")
        .text()
        .trim()
        .replace(/[^0-9.-]+/g, "")
    ) >
      Number(
        $free_shipping
          .text()
          .trim()
          .replace(/[^0-9.-]+/g, "")
      )
  ) {
    $product_tax.text("Tax and shipping included.");
    $free_shipping.addClass("hidden");
  }
  var x = 10;
  var interval = 500;
  for (var i = 0; i < x; i++) {
    setTimeout(function () {
      var $dd = jQuery("cart-items dd").not(".processed");
      if ($dd.length > 0) {
        var $html = $dd.html().replace(/✅/g, "<br>✅");
        $dd.html($html).addClass("processed");
      }

      if (typeof RSConfig !== "undefined" && !currency_processed) {
        if (RSConfig.shopMoneyFormat.indexOf("MYR") > -1) {
          _RSConfig.shopMoneyFormat = "RM{{amount}}";
          _RSConfig.shopMoneyFormatWithCurrencyFormat = "RM{{amount}}";
          RSConfig.shopMoneyFormat = "RM{{amount}}";
          RSConfig.shopMoneyFormatWithCurrencyFormat = "RM{{amount}}";
        }
        currency_processed = true;
        console.log("currency_processed = true; ");
      }
    }, i * interval);
  }
  jQuery('a[href="/products/dna-epigenetics-test"]').attr(
    "href",
    "/products/your-dna-epigenetics-based-longevity-plan?variant=47697777295633"
  );
  jQuery(".lp_review_one_liners").owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 3300,
    autoplayHoverPause: true,
    dots: true,
    pagination: true,
    margin: 0,
    autoHeight: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  });
  jQuery(".online_clinic_carousel").owlCarousel({
    nav: true,
    loop: false,
    dots: false,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  });
  jQuery(".reviews_carousel").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 0,
    autoHeight: false,
    stagePadding: 30,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
  jQuery(".signature_bundles_carousel").owlCarousel({
    nav: true,
    loop: false,
    dots: false,
    pagination: false,
    margin: 0,
    autoHeight: false,
    stagePadding: 50,
    responsive: {
      0: {
        items: 1,
      },
      992: {
        items: 2,
      },
      1400: {
        items: 3,
      },
    },
  });

  jQuery(".new_ll_carousel").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 100,
    responsive: {
      0: {
        items: 1,
        margin: 1,
        stagePadding: 35,
      },
      992: {
        items: 1,
        stagePadding: 100,
      },
      1200: {
        items: 1,
        stagePadding: 150,
      },
    },
  });


  jQuery(".leading_experts_carousel").owlCarousel({
    nav: true,
    loop: false,
    dots: false,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 100,
    responsive: {
      0: {
        items: 1,
        margin: 3,
        stagePadding: 50,
      },
      1200: {
        items: 1,
        margin: 10,
        stagePadding: 250,
      },
      1400: {
        stagePadding: 100,
        items: 2,
      },
      1800: {
        items: 2,
        stagePadding: 150,
      },
    },
  });
  jQuery(".leading_experts_carousel_2").owlCarousel({
    nav: false,
    loop: false,
    dots: true,
    pagination: false,
    margin: 0,
    autoHeight: false,
    stagePadding: 0,
    //  autoplay:true,
    // autoplayTimeout:3700,
    // autoplayHoverPause:true,
    // rewind: true,
    responsive: {
      0: {
        items: 1,
        margin: 0,
        stagePadding: 0,
      },
      768: {
        items: 1,
        stagePadding: 50,
      },
      992: {
        items: 1,
        stagePadding: 50,
      },
      1200: {
        items: 2,
        stagePadding: 50,
      },
      1500: {
        items: 1,
        stagePadding: 225,
      },
    },
  });


  if (jQuery(window).width() < 768) {
    new Readmore(".online_clinic_carousel .the_content", {
      speed: 500,
      collapsedHeight: 200,
      heightMargin: 0,
    });
    new Readmore(".leading_experts_carousel  .the_content", {
      speed: 500,
      collapsedHeight: 250,
      heightMargin: 0,
    });
    // new Readmore('.reviews_carousel .item', {
    //   speed: 500,
    //   collapsedHeight: 350,
    //   heightMargin: 0
    // });
  } else {
    new Readmore(".online_clinic_carousel .the_content", {
      speed: 500,
      collapsedHeight: 100,
      heightMargin: 0,
    });
    leading_experts_auto_height();
    jQuery(window).resize(function () {
      leading_experts_auto_height();
    });
  }
});
function leading_experts_auto_height() {
  setTimeout(function () {
    var $e = jQuery(".leading_experts_carousel .item > .row");
    $e.css("height", "auto");
    var max_leading_expert_height = 0;
    $e.each(function () {
      var $height = jQuery(this).height();
      if ($height > max_leading_expert_height) {
        max_leading_expert_height = $height;
      }
    });
    $e.css("height", max_leading_expert_height + "px");
  }, 500);
}

var auto_number = 1;
jQuery(".article-template__content > h2, .article-template__content > h3").each(
  function () {
    var $this = jQuery(this);
    var regexp = /^(\d\d)(.*)/g;
    var matches = $this.text().trim().matchAll(regexp);
    if ($this.is("h3")) {
      var font_size = 80;
    } else {
      font_size = 100;
    }
    for (const match of matches) {
      var number = match[1].trim();
      var title = match[2].trim();
    }
    if (parseInt(number) > 0) {
      auto_number = parseInt(number) + 1;
      $this.text(title);
      jQuery(
        '<div class="big_number"><div class="ll_copper_dark_text" style="font-size:' +
          font_size +
          '%">' +
          number +
          "</div></div>"
      ).insertBefore(jQuery(this));
    } else {
      var regexp = /^(##)(.*)/g;
      var matches = $this.text().trim().matchAll(regexp);
      for (const match of matches) {
        if (match.length >= 1) {
          title = match[2].trim();
          $this.text(title);
          var auto_number_parsed = auto_number.toString().padStart(2, "0");
          jQuery(
            '<div class="big_number"><div class="ll_copper_dark_text" style="font-size:' +
              font_size +
              '%">' +
              auto_number_parsed +
              "</div></div>"
          ).insertBefore(jQuery(this));
          auto_number++;
        }
      }
    }
  }
);
var $le_options = document.getElementById(
  "Option-template--21483663524113__main-0"
);
if ($le_options !== null) {
  var cur_ind = $le_options.selectedIndex;

  function update_based_on_cur_ind(cur_ind) {
    jQuery('[class^="var-"]')
      .not(".var-" + cur_ind)
      .hide();
    jQuery(".var-" + cur_ind).show();
    var $h3 = jQuery("h3.var-" + cur_ind);
    if ($h3.text() != "") {
      jQuery(".product__title h1").text($h3.text());
    }
  }
  update_based_on_cur_ind(cur_ind);
  jQuery(".product-form__input--dropdown select option").each(function (i, e) {
    var $this = jQuery(this);
    var $html = $this
      .html()
      .replace(/✅/g, "<br>✅")
      .replace(/- \d+? in cart/g, "")
      .trim();
    var checked = i == cur_ind ? "checked" : "";
    jQuery(
      "<label class='ll_card'><input type='radio' name='radio_for_dropdown' " +
        checked +
        " /><div class='ll_card_details'>" +
        $this.attr("data-price").replace(" MYR", "") +
        " - " +
        $html +
        "</div></label>"
    )
      .attr("value", $this.val())
      .click(function () {
        jQuery(".product-form__input--dropdown select").val($this.val());
        const event = new Event("change", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        document
          .getElementById("Option-template--21483663524113__main-0")
          .dispatchEvent(event);

        var cur_ind = document.getElementById(
          "Option-template--21483663524113__main-0"
        ).selectedIndex;
        update_based_on_cur_ind(cur_ind);
      })
      .insertBefore("variant-selects");
  });
}
// REMEMBER TO PUT THE POSITIVE CONDITIONS BEFORE THE NEGATIVE
if (typeof meta !== "undefined" && typeof meta.product !== "undefined") {
  if (meta.product.id == 9037719503121) {
    // full program
    jQuery(".benefits_container_program")
      .insertAfter('[id^="MainProduct-template"] product-form')
      .removeClass("hidden");
  } else if (meta.product.id == 9059566321937) {
    // Epigenetics First Test
    window.location.replace(
      "https://40dca2.myshopify.com/products/your-dna-epigenetics-based-longevity-plan?variant=47697777295633"
    );
  } else if (
    meta.product.id != 8986344849681 &&
    meta.product.id != 9035589419281
  ) {
    // Epigenetic re-test && Clinic consultation
    jQuery(".benefits_container")
      .insertAfter('[id^="MainProduct-template"] product-form')
      .removeClass("hidden");
  }
  if (meta.product.id == 9035589419281) {
    //  Clinic consultation
    jQuery(".product_page_tips").remove();
  }
}
jQuery(".article-template__content > *, .product__description > *").each(
  function () {
    var $this = jQuery(this);
    var regexp = /\[CTA:(.*?):(.*?):(.*?)\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      var cta_text = match[1].trim();
      var cta_button = match[2].trim();
      var cta_link = match[3].trim();
      if (match.length >= 2) {
        return $this.html(
          '<div class="cta cta--dark cta--with-button"><div class="cta__body"><h3 class="cta__title">' +
            cta_text +
            '</h3><a href="' +
            cta_link +
            '" class="cta__button button caret caret--dark">' +
            cta_button +
            "</a></div></div>"
        );
      }
    }
    var regexp = /(<img.*>).*\[CAPTION SMALL:(.*)\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      var the_img = match[1].trim();
      var the_caption = match[2].trim();
      if (match.length >= 2) {
        return $this.html(
          '<div class="col-12 col-md-6 container_img img_caption_style float-end">' +
            the_img +
            "" +
            the_caption +
            "</div>"
        );
      }
    }
    var regexp = /(<img.*>).*\[CAPTION BIG:(.*)\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      var the_img = match[1].trim();
      var the_caption = match[2].trim();
      if (match.length >= 2) {
        return $this.html(
          '<div class="row container_img img_caption_style"><div class="col-12 col-md-9">' +
            the_img +
            '</div><div class="col-12 col-md-3 align-self-end">' +
            the_caption +
            "</div></div>"
        );
      }
    }
    var regexp = /\[SUBSCRIBE\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        jQuery("footer .subscribe").clone().insertBefore($this);
        return $this.remove();
      }
    }
    var regexp = /\[PAYMENT\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        jQuery(".per_day_calculator").insertBefore($this);
        jQuery("variant-radios").insertBefore($this);
        jQuery(".loop-widget-container").insertBefore($this);
        jQuery(".product-form__quantity").insertBefore($this);
        jQuery(".ll_card").insertBefore($this);
        jQuery("product-form").parent().insertBefore($this);
        
        return $this.remove();
      }
    }
    var regexp = /\[BENEFITS PROGRAM\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        var $e = jQuery(".benefits_container_program");
        $e.removeClass("hidden");

        return $this.html($e);
      }
    }
    var regexp = /\[BENEFITS TESTKIT\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        var $e = jQuery(".benefits_container_testkit");
        $e.removeClass("hidden");

        return $this.html($e);
      }
    }
    var regexp = /\[BENEFITS\]/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        var $e = jQuery(".benefits_container");
        $e.removeClass("hidden");

        return $this.html($e);
      }
    }
    var regexp = /References/g;
    var matches = $this.html().matchAll(regexp);
    for (const match of matches) {
      if (match.length >= 1) {
        $this.css("font-size", "80%");
        var $next = $this.next();
        while ($next.length > 0) {
          $next.css("font-size", "80%");
          $next = $next.next();
        }
      }
    }
  }
);
var $levive_splash_video = jQuery("#levive_splash_video");
var $jellyfish_video = jQuery("#jellyfish_video");
var jellyvid = document.getElementById("jellyfish_video");
var vid = document.getElementById("levive_splash_video");
var $holimel_liquid = jQuery("#holimel_liquid");
var holimel_liquid_vid = document.getElementById("holimel_liquid");
var video_played_times = 0;

if (is_the_radiance && !is_the_glow) {
  holimel_liquid_vid.src =
    "https://cdn.shopify.com/videos/c/o/v/f3d588a24cb24eb69c528dbff380c71c.mp4";
  holimel_liquid_vid.load();
  holimel_liquid_vid.play();
}

if ($levive_splash_video.length > 0) {
  if (jQuery(window).width() > 767 && jQuery('body').hasClass('class-home')) {
    vid.src =
      "https://cdn.shopify.com/videos/c/o/v/3187d33b97814d6ea5fd6c1543406827.mp4";
    vid.load();
    vid.play();

    jellyvid.src =
      "https://cdn.shopify.com/videos/c/o/v/982adb4069ad49eaa1a4ec1dd1601686.mp4";
    jellyvid.load();
    jellyvid.play();
  } else if (jQuery(window).width() > 991 && window.location.pathname == "/pages/skin-longevity") {
    var splash_vid_link = "https://cdn.shopify.com/s/files/1/0779/0444/5713/files/skin_longevity_bg_desktop.jpg?v=1754358755";
    vid.src = splash_vid_link;
    $levive_splash_video.attr('poster',splash_vid_link)
    $levive_splash_video.attr('data-alt-poster',splash_vid_link)
  }
}
jQuery("body").on("click touchstart", function () {
  if (video_played_times < 3) {
    //const videoElement = document.getElementById('page_bg_video_2_video');
    var $videos = $levive_splash_video;
    for (var i = 0; i < $videos.length; i++) {
      var poster = $videos.eq(i).attr("poster");
      if ($videos[i].playing) {
        console.log(poster + " is already playing so do nothing");
      } else if (video_played_times < 3) {
        console.log(poster + " is not playing so play video now");
        $videos[i].play();
      }
    }
  }
});
jQuery(".subscribe")
  .clone()
  .addClass("lity-hide")
  .attr("id", "subscribe-popup")
  .appendTo("footer");
if (
  window.location.href.indexOf("online-clinic") > -1 ||
  window.location.href.indexOf("faq") > -1
) {
  jQuery(".page-width--narrow .rte").magicAccordion({
    openOnLoad: 0,

    // selector of accordion header
    headingTag: "h2",

    // default CSS classes
    bodyClass: "body",
    headClass: "head",
    activeClass: "active",

    // easing function
    easing: "linear",
    speed: 50,
  });
  jQuery(".magic-accordion > .body").magicAccordion({
    openOnLoad: 0,

    // selector of accordion header
    headingTag: "h3",

    // default CSS classes
    bodyClass: "body2",
    headClass: "head2",
    activeClass: "active2",

    // easing function
    easing: "linear",
    speed: 50,
  });
  jQuery(".magic-accordion > .body").each(function () {
    var $this = jQuery(this);
    $this.empty();
    var $sub_accordion = $this.next();
    $this.prepend($sub_accordion);
  });

  jQuery(".head2").each(function () {
    var $this = jQuery(this);
    var $text = $this.text();
    if ($text.indexOf("difference between DNA and Epigenetics") > -1) {
      //$this.addClass('difference_between')
      //$this.next().addClass('difference_between')
      $this
        .next()
        .clone()
        .addClass("lity-hide")
        .attr("id", "difference_between")
        .show()
        .appendTo("footer")
        .prepend(
          '<button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close="">×</button>'
        );
    }
  });
}
var currency_processed = false;

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

$.fn.isOnScreen = function () {
  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};
if (
  jQuery(".levive_clinic_step").length > 1 &&
  jQuery(window).width() < 768 &&
  false
) {
  //disabled

  const levive_clinic_steps = {};
  jQuery(".levive_clinic_step").each(function () {
    var $this = jQuery(this);
    var $big_number = $this.find(".big_number");
    var $content_container = $big_number.parent();
    var num = parseInt($big_number.text());
    var heading = $this.find("h3").text();
    var $img = $this.find("img");
    $big_number.remove();
    $this.find("h3").remove();
    $this.find("hr").remove();
    var content = $content_container.html();
    levive_clinic_steps[num] = {
      heading: heading,
      img: $img,
      content: content,
      big_number: $big_number,
    };
  });
  var clinic_mobile_html = '<div class="levive_clinic_step_accordion">';
  for (var i = 1; i < Object.keys(levive_clinic_steps).length + 1; i++) {
    clinic_mobile_html +=
      '<h2 id="step_' +
      levive_clinic_steps[i].big_number.text() +
      '">' +
      levive_clinic_steps[i].big_number.prop("outerHTML") +
      levive_clinic_steps[i].heading +
      "</h2>";
    clinic_mobile_html +=
      levive_clinic_steps[i].img.prop("outerHTML") == undefined
        ? ""
        : levive_clinic_steps[i].img.prop("outerHTML");
    clinic_mobile_html += levive_clinic_steps[i].content;
  }
  clinic_mobile_html += "</div>";
  jQuery(".levive_clinic_step")
    .eq(0)
    .empty()
    .removeClass("levive_clinic_step")
    .prepend(clinic_mobile_html);
  jQuery(".levive_clinic_step_accordion").magicAccordion({
    openOnLoad: 0,

    // selector of accordion header
    headingTag: "h2",

    // default CSS classes
    bodyClass: "body",
    headClass: "head",
    activeClass: "active",

    // easing function
    easing: "linear",
    speed: 50,
  });
  jQuery(".carousel-section").appendTo("#step_3 + .body");
  jQuery(".levive_clinic_step").closest(".shopify-section").remove();
}
jQuery(".product-form__submit").click(function () {
  var x = 10;
  var interval = 500;
  for (var i = 0; i < x; i++) {
    setTimeout(function () {
      var $dd = jQuery("#cart-notification dd").not(".processed");
      if ($dd.length > 0) {
        var $html = $dd.html().replace(/✅/g, "<br>✅");
        $dd.html($html).addClass("processed");
      }
    }, i * interval);
  }
});

last_selected_sub_opt_month = 1;
function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
per_day_calculator_basetext = jQuery(".per_day_calculator").text();

console.log(jQuery("input[name='selling_plan']").length, "spl");
//var selected_option = getUrlParameter('selected_option');
var selected_option = 2;
waitForElm(".sellingplan").then((elm) => {
  setTimeout(function () {
    $prod_info_price.css("opacity", 1);
  }, 100);
  console.log("Element is ready");
  console.log(elm.textContent);
  var x = 10;
  var interval = 500;
  jQuery(".card-information")
    .not(".processed")
    .each(function () {
      var $this = jQuery(this);
      if ($this.parent().parent().find(".sellingplan").length == 0) {
        jQuery('<div class="see_options_premium">Learn More</div>').insertAfter(
          $this
        );
      }
      var $price_regular = $this.find(".price-item--regular");
      var $price_regular_text = $this.find(".price-item--regular").text();
      if (Number($price_regular_text.replace(/[^0-9.-]+/g, "")) == 0) {
        //$price_regular.text('Only available with personalized plan')
        $price_regular.text("More info");
      }
      $this.addClass("processed");
    });

  for (var i = 0; i < x; i++) {
    setTimeout(function () {
      var selling_plan_counter = 1;
      jQuery('[id^="MainProduct-template"] .sellingplan')
        .not(".processed_selected")
        .each(function () {
          var $this = jQuery(this);
          $this.addClass("processed_selected");
          var $text = $this.text();
          if ($text.indexOf(getUrlParameter("selected_price")) > -1) {
            console.log(jQuery("input[name='selling_plan']").length, "spl2");
            $this.parent().prev().click();
          } else if (
            !!selected_option &&
            parseInt(selected_option) == selling_plan_counter
          ) {
            $this.parent().prev().click();
            update_price_on_button();
            setTimeout(function () {
              var $e = $(
                "input[type='radio'][name='selling_plan_radio'] + label"
              ); // make sub opts equal heights
              $e.css("height", "auto");
              var sub_opt_height = 0;
              $e.each(function () {
                var $height = jQuery(this).outerHeight();
                if ($height > sub_opt_height) {
                  sub_opt_height = $height;
                }
              });
              $e.css("height", sub_opt_height + "px");
            }, 100);
          }
          selling_plan_counter++;
        });
      $prod_info_price.css("opacity", 1);

      if (jQuery("input[name='selling_plan']").length > 0) {
        // sub or buy one time
        jQuery("input[name='selling_plan']")
          .not(".processed")
          .each(function () {
            var $this = jQuery(this);
            $this.addClass("processed");
            $this.change(function () {
              update_price_on_button();
              if (
                $("input[type='radio'][name='selling_plan']:checked + label")
                  .text()
                  .toLowerCase()
                  .indexOf("one time") > -1
              ) {
                $selected_sub_opt = $(
                  '.appstle-radio-input-wrapper input[type="radio"]:checked + label'
                );
                last_selected_sub_opt_month =
                  $selected_sub_opt.text().toLowerCase().indexOf("3 month") > -1
                    ? 3
                    : 1;
                $('.appstle-radio-input-wrapper input[type="radio"]').prop(
                  "checked",
                  false
                );
              } else {
                var eq_to_check = last_selected_sub_opt_month == 3 ? 0 : 1;
                $('.appstle-radio-input-wrapper input[type="radio"]')
                  .eq(eq_to_check)
                  .prop("checked", true);
              }
            });
          });

        jQuery(".quantity__button")
          .not(".processed")
          .each(function () {
            var $this = jQuery(this);
            $this.addClass("processed");
            $this.click(function () {
              update_price_on_button();
            });
          });

        jQuery("input[name='selling_plan_radio']")
          .not(".processed")
          .each(function () {
            // sub opts
            var $this = jQuery(this);
            $this.addClass("processed");
            $this.change(function () {
              var $this = jQuery(this);
              var $prepaid = $(
                "input[type='radio'][name='selling_plan']:checked + label + div .appstle_prepaid_description"
              );
              var $selling_plan_radio_checked_label = $(
                "input[type='radio'][name='selling_plan_radio']:checked + label"
              );
              var is_incl_epig_selected =
                $selling_plan_radio_checked_label
                  .text()
                  .trim()
                  .indexOf("free epig") > -1;
              if (is_incl_epig_selected) {
                jQuery("img.incl_epig_is_selected").removeClass("hidden");
                $selling_plan_radio_checked_label
                  .parent()
                  .parent()
                  .append(jQuery("img.incl_epig_is_selected"));
              } else {
                jQuery("img.incl_epig_is_selected").addClass("hidden");
              }
              if ($this.is(":checked")) {
                var labelText = $this.next("label").text().toLowerCase();
                last_selected_sub_opt_month = labelText.includes("3 month")
                  ? 3
                  : 1;
              }
              update_price_on_button();
              setTimeout(function () {
                $("input[type='radio'][name='selling_plan']").eq(1).click(); // activate sub radio
              }, 100);
            });
          });
      }

      jQuery(".sellingplan")
        .not(".processed")
        .each(function () {
          var $this = jQuery(this);

          var $card_content = $this.closest(".card__content");
          var text_criteria =
            $card_content.text().indexOf("Superbundle") > -1
              ? "3 Months"
              : "1 Month";
          var text = $this.text();
          if (text.indexOf(text_criteria) > -1) {
            var regexp = /\((.*?)\//g;
            var matches = text.matchAll(regexp);
            for (var match of matches) {
              if (match.length >= 1) {
                var the_price = match[1].replace(" MYR", "");
                var $final_price_element = $card_content.find(
                  "span.price-item.price-item--regular.appstle_subscription_final_price"
                );
                $final_price_element.text(the_price);
                var $card_information = $card_content.find(".card-information");
                var $see_options_premium = $card_content.find(
                  ".see_options_premium"
                );
                var $link = $card_content.find(".card__heading a");
                $link.attr(
                  "href",
                  $link.attr("href") + "?selected_price=" + the_price
                );
                var see_options_text = "Payment Options";
                var the_class = "see_options_premium";
                if (window.location.pathname == "/") {
                  var the_class = "see_options_premium ll_copper_dark_text";
                  if ($card_content.text().indexOf("The Rebel") > -1) {
                    see_options_text =
                      "Maximize your cell renewal with NMN & Resveratrol";
                  } else if ($card_content.text().indexOf("The Glow") > -1) {
                    see_options_text = "Anti aging skincare<br>from the inside";
                  } else if ($card_content.text().indexOf("The Ohmm") > -1) {
                    see_options_text =
                      "Unwind, relax and<br>enhance your sleep";
                  } else if ($card_content.text().indexOf("The Boost") > -1) {
                    see_options_text = "Supercharge your<br>mental performance";
                  }
                }
                if ($see_options_premium.length > 0) {
                  jQuery($see_options_premium)
                    .addClass(the_class)
                    .html(see_options_text);
                } else {
                  jQuery(
                    '<div class="' +
                      the_class +
                      '">' +
                      see_options_text +
                      "</div>"
                  ).insertAfter($card_information);
                }
              }
            }
          }
          var regexp = /(.*)\[(.*)\]/g;
          var matches = text.matchAll(regexp);
          for (var match of matches) {
            if (match.length >= 1) {
              $this.html(
                '<div class="ll_sub_plan_name">' +
                  match[1] +
                  '</div><div class="ll_sub_plan_desc">' +
                  match[2] +
                  "</div>"
              );
            }
          }
          setTimeout(function () {
            $this.addClass("processed");
          }, 500);
        });

      jQuery(".see_options_premium").not(".processed").addClass("processed");

      jQuery(".transcy-money, .appstle_subscription_final_price")
        .not(".processed")
        .each(function () {
          var $this = jQuery(this);

          // if ($this.attr('class').indexOf('appstle_subscription_compare_amount') > -1) {

          // }
          setTimeout(function () {
            var $html = $this
              .html()
              .replace(" MYR", "")
              .replace("/delivery", "/month");
            $this.html($html);
          }, 0);
          setTimeout(function () {
            $this.addClass("processed");
          }, 500);
        });
      if (typeof RSConfig !== "undefined" && currency_processed) {
        process_free_shipping_bear_currency();
      }
    }, i * interval);
  }
});
function process_free_shipping_bear_currency() {
  jQuery(".conversion-bear-money")
    .not(".processed")
    .each(function () {
      var $this = jQuery(this);
      var this_text = $this.text();
      console.log(this_text);
      var value = this_text.match(/[0-9]*\.[0-9]+/)[0];
      console.log(value);
      var money_format_string = String(RSConfig.shopMoneyFormat);
      console.log(money_format_string);
      var regexp = /^(.*)(\{\{[^}]+\}\})(.*)$/g;
      console.log(regexp);
      var matches = money_format_string.matchAll(regexp);
      console.log(matches);
      for (var match of matches) {
        console.log(match);
        if (match.length >= 1) {
          var free_shipping_money = match[1] + value + match[3];
        }
      }
      $this.text(free_shipping_money).addClass("processed");
    });
}
setInterval(process_free_shipping_bear_currency, 1000);

jQuery(".magic-accordion .head, .magic-accordion .head2").click(function () {
  var $this = jQuery(this);
  setTimeout(function () {
    if (!$this.isOnScreen()) {
      jQuery("html").animate(
        {
          scrollTop: $this.offset().top - 100,
        },
        100 //speed
      );
    }
  }, 100);
});
// START - NOT USING CONVERTFLOW POPUP AT THE MOMENT; JUST KLAVIYO. CONVERTFLOW USED FOR SIGN UP OR LANDING PAGES AT THE MOMENT
// if (!window.convertflow) {
//   var script = document.createElement("script");
//   script.async = true;
//   script.src = "https://js.convertflow.co/production/websites/57966.js";
//   document.body.appendChild(script);
// }
// END
jQuery(".card").each(function () {
  var $this = jQuery(this);
  //var $heading = $this.find(".card__heading").text();
  if (window.location.href.indexOf('collections/our-products') > -1) {
    $this.find(".card-information").hide();
  }
});
jQuery(".magic-accordion-h3").magicAccordion({
  openOnLoad: 0,

  // selector of accordion header
  headingTag: "h3",

  // default CSS classes
  bodyClass: "body",
  headClass: "head",
  activeClass: "active",

  // easing function
  easing: "linear",
  speed: 200,
});
jQuery(".magic-accordion-h3-new > div").magicAccordion({
  openOnLoad: 0,

  // selector of accordion header
  headingTag: "h3",

  // default CSS classes
  bodyClass: "body",
  headClass: "head",
  activeClass: "active",

  // easing function
  easing: "linear",
  speed: 200,
});
jQuery(".magic-accordion-faq > div").magicAccordion({
  openOnLoad: 0,

  // selector of accordion header
  headingTag: "h3",

  // default CSS classes
  bodyClass: "body",
  headClass: "head",
  activeClass: "active",

  // easing function
  easing: "linear",
  speed: 200,
});
if (is_the_radiance) {
  jQuery("body").addClass("the_radiance");
  var divisor = document.getElementById("divisor"),
    handle = document.getElementById("handle"),
    slider = document.getElementById("slider");

  function moveDivisor() {
    handle.style.left = slider.value + "%";
    divisor.style.width = slider.value + "%";
  }
  if (is_the_radiance && !is_the_glow) {
    window.onload = function () {
      moveDivisor();
    };
  }  
}
if (jQuery(".product__description").text().indexOf("launch discount") > -1) {
  jQuery(".product-form__submit > span").text("Secure launch discount");
  jQuery(".price__container, .price-per-item__container").hide();
  jQuery(".product-form__submit").click(function (e) {
    e.preventDefault();
    window.location.href =
      "https://welcome.levivelabs.com/waitlist?preorder_productname=" +
      document.title;
  });
}
var is_root = location.pathname == "/";
// START OLD POP UP - WE ARE USING NEW KLAVIYO POP UP NOW SO THIS CAN BE REMOVED - 5 SEP 2025
// var quiz_popup_time = is_root ? 3500 : 5000;
// console.log(window.location.href);
// var popup_cookie_name = "popped_up_ll";
// if (
//   (Cookies.get(popup_cookie_name) !== "dismissed" &&
//     window.location.href.indexOf("oseid=") < 0 &&
//     window.location.href.indexOf("/pages/quiz") < 0) ||
//   window.location.href.indexOf("?popup") > 0
// ) {
//   setTimeout(function () {
//     lity("#quiz");
//     jQuery(document).on("lity:close", function (event, instance) {
//       Cookies.set(popup_cookie_name, "dismissed", { expires: 30 });
//       console.log("Lightbox closed");
//     });
//   }, quiz_popup_time);
// }
// END OLD POP UP
jQuery('.product__description a[href^="#the_"]').attr("data-lity", "");
should_maintain_black_nav =
  window.location.href.indexOf("lets-talk-science") > -1 ||
  window.location.href.indexOf("pages/the") > -1;

pages_with_landing_video =
  window.location.pathname == "/" ||
  window.location.href.indexOf("launch-pad") > -1 ||
  window.location.href.indexOf("pages/skin-longevity") > -1 ||
  window.location.href.indexOf("rebelsofaging") > -1;

$sticky_header = $("sticky-header");
if (pages_with_landing_video || should_maintain_black_nav) {
  jQuery("body").addClass("ver_2024");
  if (pages_with_landing_video) {
    $sticky_header.addClass("transparent");
  }
}
window.addEventListener("load", scrollAnimate);
window.addEventListener("scroll", scrollAnimate);

function scrollAnimate() {
  if (document.querySelectorAll(".animated_percentage .circle").length > 0) {
    var windowHeight = window.innerHeight,
      videoEl = document.querySelectorAll(".animated_percentage .circle");

    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
        videoHeight = thisVideoEl.clientHeight,
        videoClientRect = thisVideoEl.getBoundingClientRect().top;

      if (
        videoClientRect <= windowHeight - videoHeight * 0.5 &&
        videoClientRect >= 0 - videoHeight * 0.5
      ) {
        setTimeout(function () {
          jQuery(".animated_percentage .odometer").text("80");
          jQuery(".animated_percentage .circle").addClass("animated");
        }, 150);
      } else {
        // thisVideoEl.pause();
      }
    }
  }
}

$(window).scroll(function () {
  if ($(this).scrollTop() == 0) {
    if (pages_with_landing_video) {
      $sticky_header.addClass("transparent");
    }
  } else {
    $sticky_header.removeClass("transparent");
  }
});
init_lity_prod("the_rebel");
init_lity_prod("the_boost");
init_lity_prod("the_glow");
init_lity_prod("the_ohmm");

function init_lity_prod(prod_name) {
  var the_product = prod_name;
  var first = true;
  jQuery(".product__description > ." + the_product).each(function () {
    var $this = jQuery(this);
    if (first) {
      jQuery(
        '<div id="' +
          the_product +
          '" class="lity-hide simple_lity"><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close="">×</button></div>'
      ).insertBefore($this);
      first = false;
    }
    jQuery("#" + the_product).append($this);
  });
}
setTimeout(function () {
  if (jQuery(".lity-container:visible").length == 0) {
    jQuery("#quiz").addClass("lity-hide");
  }
}, 2500);
function initializeAccordion(){
  // (Optional) Active an item if it has the class "is-active"
  $(".accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown();

  $(".accordion > .accordion-item").click(function () {
    // Cancel the siblings
    $(this)
      .siblings(".accordion-item")
      .removeClass("is-active")
      .children(".accordion-panel")
      .slideUp();
    // Toggle the item
    $(this)
      .toggleClass("is-active")
      .children(".accordion-panel")
      .slideToggle("ease-out");
  });
}
$login = jQuery(".header__icon--account");
$login.addClass("dropdown");
$login.click(function (e) {
  e.preventDefault();
  var $this = $(this);

  if ($this.next(".dropdown_menu").hasClass("open")) {
    $this.removeClass("active");
    $this.next(".dropdown_menu").removeClass("open");
    $this.next(".dropdown_menu").fadeOut("fast");
  } else {
    $this.addClass("active");
    $this.next(".dropdown_menu").addClass("open");
    $this.next(".dropdown_menu").fadeIn("fast");
  }
});
jQuery(".new_ll_lp_nav a").each(function () {
  var $this = jQuery(this);
  if (window.location.href.indexOf($this.attr("href")) > -1) {
    $this.addClass("active");
  }
});
if ($(".new_ll_lp_nav.scroll").length > 0) {
  var $navPosition = $(".new_ll_lp_nav.scroll").scrollLeft(),
    $elemPosition = $(".new_ll_lp_nav.scroll a.active").offset().left;
}

$(".new_ll_lp_nav.scroll").animate(
  { scrollLeft: $navPosition + $elemPosition },
  0
);

jQuery(
  '<ul class="dropdown_menu"><li><a href="https://launchpad.levivelabs.com/registration/">access launch pad</li><li><a id="my_purchases" href="' +
    $login.attr("href") +
    '">my purchases</li></ul>'
).insertAfter($login);
jQuery(".ll_card_item:not(.ll_card_wide) > .d-flex").each(function () {
  var $this = jQuery(this);
  var $a = $this.find("a");
  if ($a.length == 1) {
    $this.css("cursor", "pointer");
    $this.click(function (e) {
      window.location.href = $a.attr("href");
      e.stopPropagation();
    });
  }
});
jQuery(document).ready(function () {
  var videoSlider = jQuery(".owl_videos");
  videoSlider.owlCarousel({
    //loop:true,
    center: true,
    rewind: true,
    dots: false,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        startPosition: 0,
      },
      480: {
        items: 1,
        startPosition: 0,
      },
      600: {
        items: 1,
        startPosition: 0,
      },
      768: {
        items: 3,
        startPosition: 1,
      },
      900: {
        items: 3,
        startPosition: 1,
      },
      1024: {
        items: 3,
        startPosition: 1,
      },
      1200: {
        items: 5,
        startPosition: 2,
      },
      1400: {
        items: 5,
        startPosition: 2,
      },
      1600: {
        items: 5,
        startPosition: 2,
      },
      1800: {
        items: 5,
        startPosition: 2,
      },
      2000: {
        items: 7,
        startPosition: 3,
      },
      2400: {
        items: 7,
        startPosition: 3,
      },
    },
  });
  owl_videos_translated_n_autoplay_next = false;
  videoSlider.on("translated.owl.carousel", function (e) {
    var $this = jQuery(this);
    $this.find("video").each(function () {
      var $this = jQuery(this);
      if ($this.isOnScreen()) {
        $this.attr({
          //autoplay: '',
          preload: "auto",
        });
      }
    });
    $this.find("video").each(function () {
      // pause playing video - after sliding
      jQuery(this).get(0).muted = true;
      //if (jQuery(window).width() > 767) {
      jQuery(this).get(0).pause();
      //}
    });
    var $active_vid = jQuery(".owl-item.active.center").find("video");
    if ($active_vid.length !== 0 && $active_vid.isOnScreen()) {
      // play video in active slide
      var thisVideoEl = $active_vid.get(0);
      thisVideoEl.play();
      thisVideoEl.muted = false;
      $volume_switcher = $active_vid.parent().find(".volume-switcher");
      $volume_switcher.prop("checked", true);
      thisVideoEl.onended = function () {
        owl_videos_translated_n_autoplay_next = true;
        thisVideoEl.muted = true;
        if ($volume_switcher.prop("checked") == true) {
          videoSlider.trigger("next.owl.carousel");
        } else {
          thisVideoEl.play();
        }
        $volume_switcher.prop("checked", false);
      };
    }
  });
  jQuery(".volume-switcher").on("change", function () {
    var $this = jQuery(this);
    var vid = $this.parent().find("video").get(0);
    vid.muted = !this.checked;
    if (vid.paused) {
      vid.play();
    }
    // if (!owl_videos_translated_n_autoplay_next) {
    //   var thisVideoEl = vid;
    //   thisVideoEl.onended = function() {
    //       owl_videos_translated_n_autoplay_next = true;
    //       thisVideoEl.muted = true;
    //       if ($volume_switcher.prop( "checked" ) == true) {
    //         videoSlider.trigger('next.owl.carousel');
    //       } else {
    //         thisVideoEl.play();
    //       }
    //       $volume_switcher.prop( "checked", false );
    //   }
    // }
  });

  $(document).on("click", ".owl-item", function () {
    owlIndex = $(this).index();
    $(".owl-stage-outer").trigger("to.owl.carousel", owlIndex);
  });
});
owl_videos_activated = false;
$(window).scroll(function () {
  var videoSlider = jQuery(".owl_videos");
  if (videoSlider.length == 0) {
    return;
  }
  var $active_vid = jQuery(".owl-item.active.center").find("video");
  if ($active_vid.length !== 0 && $active_vid.isOnScreen()) {
    var thisVideoEl = $active_vid.get(0);
    thisVideoEl.play();
    $volume_switcher = $active_vid.parent().find(".volume-switcher");
    //$volume_switcher.prop( "checked", true );
    thisVideoEl.onended = function () {
      owl_videos_translated_n_autoplay_next = true;
      thisVideoEl.muted = true;
      if ($volume_switcher.prop("checked") == true) {
        videoSlider.trigger("next.owl.carousel");
      } else {
        thisVideoEl.play();
      }
      $volume_switcher.prop("checked", false);
    };
  }
  if (!owl_videos_activated) {
    if (videoSlider.isOnScreen()) {
      videoSlider.find("video").each(function () {
        var $this = jQuery(this);
        if ($this.isOnScreen()) {
          $this.attr({
            //autoplay: '',
            preload: "auto",
          });
          owl_videos_activated = true;
        }
      });
    }
  }
});

jQuery(document).ready(function () {
  (function ($) {
    var lityOpen = false;
    var currentLityInstance = null;
    
    // On Lity open, push a state and save instance
    $(document).on("lity:open", function (event, instance) {
      lityOpen = true;
      currentLityInstance = instance; // Save the instance
      history.pushState(
        { lity: true },
        "",
        window.location.href.indexOf("#") === -1 
          ? window.location.href + "#popup"
          : window.location.href.split('#')[0] + "#popup"
      );
    });
    
    // Handle popstate (back button)
    window.addEventListener("popstate", function (event) {
      if (lityOpen && (!event.state || !event.state.lity)) {
        if (currentLityInstance) {
          currentLityInstance.close();
        } else {
          console.warn("No current Lity instance to close");
        }
        lityOpen = false;
      }
    });
    
    // On Lity close
    $(document).on("lity:close", function (event, instance) {
      lityOpen = false;
      currentLityInstance = null;
      // If popup was closed normally (not via back button), go back in history
      if (window.location.hash === "#popup") {
        history.back(); // This removes the pushed state and restores the previous URL
      }
    });
  })(jQuery);
});

/**
 * Custom JS for Widget Handling
 */

/** END CUSTOM JS FOR WIDGET HANDLING */